export default "__VITE_ASSET__B$2NY2FC__"